<template>
  <div class="loading-overlay" v-if="visible">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <div class="loading-text">{{ loadingText }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingIndicator',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'Loading...'
    }
  }
})
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Opaque overlay so underlying UI/scene doesn't "pop" during preload */
  background: rgb(250, 250, 250);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: none;
  animation: fadeIn 0.3s ease-in-out;
}

.loading-content {
  text-align: center;
  color: rgb(0, 0, 0);
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(0, 0, 0, 0.12);
  border-top: 4px solid rgb(0, 0, 0);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px auto;
}

.loading-text {
  font-size: 18px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { 
    opacity: 0;
    backdrop-filter: none;
  }
  to { 
    opacity: 1;
    backdrop-filter: none;
  }
}
</style> 